import View from './View';

export { default as View, getCastMediaDetailStyles } from './View';

export default View;
